var React = require('react');

function EyeClosedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.127 6.511l.49-.872 1.744.977-.488.873C13.843 11.113 11.2 13 8 13 4.799 13 2.157 11.113.127 7.489l-.488-.873 1.745-.977.489.872C3.576 9.553 5.6 11 8 11c2.399 0 4.424-1.447 6.127-4.489zM3.822 5.677L2.432 4.24C3.969 2.753 5.842 2 8 2c2.241 0 4.175.813 5.744 2.415l-1.429 1.4C11.123 4.596 9.704 4 8 4c-1.64 0-3.015.553-4.178 1.677zM7 12h2v3H7v-3zM2.553 9.658l1.789.895-1.895 3.789-1.789-.895 1.895-3.789zm9.105.895l1.79-.895 1.894 3.79-1.79.894-1.894-3.79z","fill":"currentColor"}));
}

EyeClosedInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = EyeClosedInline;

EyeClosedInline.default = EyeClosedInline;
